import { Search, X } from 'lucide-react'
import { Input } from '@/components/ui/input'
import { Select } from '@/components/ui/select'
import { Button } from '@/components/ui/button'
import { DateRangePicker } from '@/components/shared/DateRangePicker'
import type { Filters } from '@/types'

interface UserFiltersProps {
  filters: Filters
  onChange: (filters: Filters) => void
}

export function UserFilters({ filters, onChange }: UserFiltersProps) {
  const clearDateFilter = () => {
    onChange({ ...filters, dateFrom: undefined, dateTo: undefined, page: 1 })
  }

  const hasDateFilter = filters.dateFrom || filters.dateTo

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-wrap items-center gap-4">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
          <Input
            placeholder="사용자 검색..."
            value={filters.search}
            onChange={(e) => onChange({ ...filters, search: e.target.value, page: 1 })}
            className="w-64 pl-9"
          />
        </div>

        <Select
          value={filters.sortBy}
          onChange={(e) => onChange({ ...filters, sortBy: e.target.value, page: 1 })}
        >
          <option value="created_at">생성일</option>
          <option value="last_active_at">최근 활동</option>
          <option value="message_count">메시지</option>
          <option value="thread_count">스레드</option>
        </Select>

        <Select
          value={filters.order}
          onChange={(e) =>
            onChange({ ...filters, order: e.target.value as 'asc' | 'desc', page: 1 })
          }
        >
          <option value="desc">내림차순</option>
          <option value="asc">오름차순</option>
        </Select>

        <Select
          value={filters.limit.toString()}
          onChange={(e) =>
            onChange({ ...filters, limit: parseInt(e.target.value), page: 1 })
          }
        >
          <option value="10">10개씩 보기</option>
          <option value="20">20개씩 보기</option>
          <option value="50">50개씩 보기</option>
        </Select>
      </div>

      <div className="flex items-center gap-2">
        <span className="text-sm text-muted-foreground">가입일 필터:</span>
        <DateRangePicker
          startDate={filters.dateFrom ?? ''}
          endDate={filters.dateTo ?? ''}
          onStartDateChange={(date) =>
            onChange({ ...filters, dateFrom: date || undefined, page: 1 })
          }
          onEndDateChange={(date) =>
            onChange({ ...filters, dateTo: date || undefined, page: 1 })
          }
        />
        {hasDateFilter && (
          <Button variant="ghost" size="sm" onClick={clearDateFilter}>
            <X className="h-4 w-4" />
          </Button>
        )}
      </div>
    </div>
  )
}
